import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ListarArquivosPageRoutingModule } from './listar-arquivos-routing.module';

import { ListarArquivosPage } from './listar-arquivos.page';
import { ComponentsModule } from 'src/app/components/components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ComponentsModule,
    ListarArquivosPageRoutingModule
  ],
  declarations: [ListarArquivosPage]
})
export class ListarArquivosPageModule {}
